import { type GeneratedImage, type Image } from '@prisma/client'
import { useQuery } from '@tanstack/react-query'

async function fetchGeneratedImageData(
	imageId: string,
	ownerId: string,
): Promise<GeneratedImage & { image: Image }> {
	const response = await fetch(
		`/resources/generated-image/${ownerId}/${imageId}`,
	)
	if (!response.ok) {
		throw new Error('Failed to fetch generated image data')
	}
	const data = await response.json()
	return data as GeneratedImage & { image: Image }
}

export function useGeneratedImageData(
	open: boolean,
	imageId: string,
	ownerId: string,
) {
	const { data, isLoading, error } = useQuery({
		queryKey: ['generatedImageData', imageId],
		queryFn: () => fetchGeneratedImageData(imageId, ownerId),
		enabled: open && !!imageId,
	})

	return { data, isLoading, error }
}
